import { INotificationContext } from "./NotificationProvider.types";

export const defaultNotificationContextState: INotificationContext = {
  items: [],
  unreadCount: 0,
  totalRecords: 0,
  streamConnected: false,
  loading: false,
  popups: [],
  fetchList: async () => {},
  markRead: async () => {},
  markAllRead: async () => {},
  clearAllRead: async () => 0,
  refreshUnreadCount: async () => {},
  setActiveFilters: () => {},
  subscribe: () => () => {},
  dismissPopup: () => {},
};
